module.exports = __webpack_public_path__ + "static/media/logo-arc.02ddb4da.svg";